import { breakpointVal, iconOrderBefore, IconSvg } from '@graphcommerce/next-ui'
import { Box, darken, lighten, useTheme } from '@mui/material'
import Link from 'next/link'


export function ProductSidebarDelivery(props) {
  const { product, quantity } = props;
  const { sku } = product;

  function calcWorkingDays(fromDate, days) {
    if (Number.isNaN(Number(days))) {
      let count = 0;
      while (count < 8) {
        fromDate.setDate(fromDate.getDate() + 1);
        if (fromDate.getDay() != 0 && fromDate.getDay() != 6)
          count++;
      }
      return fromDate;
    }
    let count = 0;
    while (count < days) {
      fromDate.setDate(fromDate.getDate() + 1);
      if (fromDate.getDay() != 0 && fromDate.getDay() != 6)
        count++;
    }
    return fromDate;
  }

  let title = `Free Shipping - Get it around ${calcWorkingDays(new Date(), 8).toLocaleDateString('en-us', { weekday: "short", month: "short", day: "numeric" })}`
  let subtitle = 'Need it sooner?'
  const theme = useTheme();

  return (
    <Box
      sx={(theme) => ({
        display: 'grid',
        alignItems: 'center',
        gridTemplate: `
          "image title"
          ".     subtitle"
        `,
        gridTemplateColumns: `min-content auto`,
        columnGap: theme.spacings.xxs,
        background:
          theme.palette.mode === 'light'
            ? darken(theme.palette.background.default, 0.01)
            : lighten(theme.palette.background.default, 0.2),
        padding: theme.spacings.xxs,
        ...breakpointVal(
          'borderRadius',
          theme.shape.borderRadius * 3,
          theme.shape.borderRadius * 4,
          theme.breakpoints.values,
        ),
      })}
    >
      <IconSvg src={iconOrderBefore} size='small' sx={{ gridArea: 'image' }} />
      <Box sx={{ typography: 'body2', gridArea: 'title', fontWeight: 600 }}>{title}</Box>
      <Box sx={{ typography: 'body2', gridArea: 'subtitle', color: 'text.primary' }}>
        {subtitle} {quantity ? <Link href={`/shipping?p=${sku}&q=${quantity}`} style={{ color: theme.palette.primary.main }}>Choose Rush or Super Rush</Link>
          :
          <Link href={`/shipping?p=${sku}`} style={{ color: theme.palette.primary.main }}>Choose Rush or Super Rush</Link>}
      </Box>
    </Box>
  )
}
